const reportsGenerated = (state = [], action) => {
  switch (action.type) {
    case 'SET_REPORTS_GENERATED':
      return action.reports_generated
    default:
      return state
  }
}

export default reportsGenerated
